import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const PMKisanTrendChart = ({ data, isHindi, darkMode }) => {
  const chartData = data['chart-data'] || [];

  // Dark mode theme configuration
  const chartTheme = darkMode
    ? {
        backgroundColor: '#234046',
        textColor: '#FFFFFF',
        gridLineColor: '#3B3B3B',
        lineColor: '#575757',
      }
    : {
        backgroundColor: '#FFFFFF',
        textColor: '#2B2B2B',
        gridLineColor: '#E6E6E6',
        lineColor: '#CCCCCC',
      };

  // Create detailed labels: "1st Inst. Dec-Mar 18-19"
  const categories = chartData.map((item) => {
    const monthRange = item.period.split(' ')[0]; // "DEC–MAR"
    const year = item.period.split(' ')[1]; // "2018-19"
    return `${item.installment} Inst. ${monthRange} ${year}`;
  });
  const beneficiariesData = chartData.map((item) => item.beneficiaries);

  const options = {
    chart: {
      type: 'line',
      height: 420,
      backgroundColor: chartTheme.backgroundColor,
    },
    title: {
      text: '',
    },
    xAxis: {
      categories,
      title: {
        text: data?.xAxis?.title || isHindi ? 'अवधि / किस्त' : 'Period / Installment',
        style: {
          color: chartTheme.textColor,
        },
      },
      labels: {
        rotation: -45,
        style: {
          fontSize: '9px',
          color: chartTheme.textColor,
        },
      },
      lineColor: chartTheme.lineColor,
      tickColor: chartTheme.lineColor,
    },
    yAxis: {
      min: 0,
      title: {
        text:
          data?.yAxis?.[0]?.title || isHindi ? 'लाभार्थी (करोड़ में)' : 'Beneficiaries (in crore)',
        style: {
          color: chartTheme.textColor,
        },
      },
      labels: {
        style: {
          color: chartTheme.textColor,
        },
      },
      gridLineColor: chartTheme.gridLineColor,
    },
    tooltip: {
      valueSuffix: data?.tooltip?.valueSuffix || ' Cr',
      pointFormat: isHindi ? '<b>{point.y}</b> लाभार्थी' : '<b>{point.y}</b> beneficiaries',
      shared: true,
      backgroundColor: darkMode ? '#3B3B3B' : '#FFFFFF',
      borderColor: darkMode ? '#575757' : '#CCCCCC',
      style: {
        color: chartTheme.textColor,
      },
    },
    legend: {
      enabled: data?.legend ?? false,
      itemStyle: {
        color: chartTheme.textColor,
      },
      itemHoverStyle: {
        color: darkMode ? '#FFFFFF' : '#000000',
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false,
        },
        marker: {
          enabled: true,
          radius: 4,
        },
      },
    },
    series: [
      {
        name:
          data?.seriesConfig?.[0]?.name || isHindi
            ? 'लाभार्थी (करोड़ में)'
            : 'Beneficiaries (in crore)',
        color: data?.seriesConfig?.[0]?.color || '#2E6CF6',
        data: beneficiariesData,
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default PMKisanTrendChart;
